var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportOutlineBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12328",
    "data-name": "Group 12328",
    transform: "translate(-8 -10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18140",
    "data-name": "Rectangle 18140",
    width: 28,
    height: 28,
    transform: "translate(8 10)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\xCDCONE",
    transform: "translate(-393.419 -464.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12691",
    "data-name": "Caminho 12691",
    d: "M419.09,506.285h9.264a.754.754,0,0,0,0-1.469H419.09a.754.754,0,0,0,0,1.469Z",
    transform: "translate(-8.311 -19.212)",
    fill: "#2F64F5",
    stroke: "#2F64F5",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12692",
    "data-name": "Caminho 12692",
    d: "M419.08,516.9h9.065a.735.735,0,0,0,0-1.469H419.08a.735.735,0,0,0,0,1.469Z",
    transform: "translate(-8.205 -25.554)",
    fill: "#2F64F5",
    stroke: "#2F64F5",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12693",
    "data-name": "Caminho 12693",
    d: "M414.143,499.12h-6.018a.725.725,0,0,1-.724-.726h0v-15.37h5.089a.726.726,0,0,0,.724-.726v-5.159h9.456a.773.773,0,0,1,.776.726l.006,21.987a.724.724,0,1,0,1.448,0l-.006-21.984a2.226,2.226,0,0,0-2.221-2.188H412.491a.728.728,0,0,0-.517.216l-5.823,5.884a.733.733,0,0,0-.207.519v16.092a2.188,2.188,0,0,0,2.182,2.188H424.17a.729.729,0,1,0,.006-1.459Zm-2.38-20.939v3.383h-3.345Z",
    transform: "translate(0 0)",
    fill: "#2F64F5",
    stroke: "#2F64F5",
    strokeWidth: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportOutlineBlue);
export default __webpack_public_path__ + "static/media/report_outline_blue.378ad2adb3549413269611d85431b813.svg";
export { ForwardRef as ReactComponent };